"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailureType = void 0;
exports.instanceOfFailureType = instanceOfFailureType;
exports.FailureTypeFromJSON = FailureTypeFromJSON;
exports.FailureTypeFromJSONTyped = FailureTypeFromJSONTyped;
exports.FailureTypeToJSON = FailureTypeToJSON;
exports.FailureTypeToJSONTyped = FailureTypeToJSONTyped;
/**
 *
 * @export
 */
exports.FailureType = {
    ShiftConflictsFound: 'ShiftConflictsFound',
    AssignedShiftConflictsFound: 'AssignedShiftConflictsFound',
    NurseBlockedFromPlatform: 'NurseBlockedFromPlatform',
    NurseBlockedFromFacility: 'NurseBlockedFromFacility',
    CertificationsRequired: 'CertificationsRequired',
    CertificationsExpired: 'CertificationsExpired',
    ContractsRequired: 'ContractsRequired',
    ConfidentialityAgreementRequired: 'ConfidentialityAgreementRequired',
    DhsBackgroundCheckNotEligible: 'DhsBackgroundCheckNotEligible',
    EmrSystemsRequired: 'EmrSystemsRequired',
    NotVerifiedAtFacility: 'NotVerifiedAtFacility',
    FitTestingDocumentationRequired: 'FitTestingDocumentationRequired',
    GeneralBackgroundCheckNotAuthorized: 'GeneralBackgroundCheckNotAuthorized',
    NoVerifiedLicensesFound: 'NoVerifiedLicensesFound',
    LicensesExpired: 'LicensesExpired',
    PayrollOnboardingNotCompleted: 'PayrollOnboardingNotCompleted',
    PersonalInformationRequired: 'PersonalInformationRequired',
    NoValidRegulatoryAssessmentGroups: 'NoValidRegulatoryAssessmentGroups',
    RegulatoryAssessmentGroupsExpired: 'RegulatoryAssessmentGroupsExpired',
    ResumeUploadRequired: 'ResumeUploadRequired',
    SpecialtiesRequired: 'SpecialtiesRequired',
    SpecialtyAssessmentsMustBePassed: 'SpecialtyAssessmentsMustBePassed',
    SpecificSpecialtyRequired: 'SpecificSpecialtyRequired',
    SpecificSpecialtyAssessmentMustBePassed: 'SpecificSpecialtyAssessmentMustBePassed',
    SpecificSpecialtyCertificationRequired: 'SpecificSpecialtyCertificationRequired',
    NotAuthorizedToPracticeInState: 'NotAuthorizedToPracticeInState',
    NoLicenseForState: 'NoLicenseForState',
    StateLicenseExpired: 'StateLicenseExpired',
    TuberculosisScreeningRequired: 'TuberculosisScreeningRequired',
    TuberculosisTestRequired: 'TuberculosisTestRequired',
    TuberculosisTestOutdated: 'TuberculosisTestOutdated',
    TuberculosisTestRequiredBasedOnScreening: 'TuberculosisTestRequiredBasedOnScreening',
    TuberculosisTestRequiredAfterExposure: 'TuberculosisTestRequiredAfterExposure',
    UnableToDetermineMinimumValidTestDate: 'UnableToDetermineMinimumValidTestDate',
    VaccinationsMissing: 'VaccinationsMissing',
    InfluenzaVaccinationExpirationDateRequired: 'InfluenzaVaccinationExpirationDateRequired',
    VaccinationsExpired: 'VaccinationsExpired',
    VaccinationsRejected: 'VaccinationsRejected',
    VaccinationsPendingReview: 'VaccinationsPendingReview'
};
function instanceOfFailureType(value) {
    for (const key in exports.FailureType) {
        if (Object.prototype.hasOwnProperty.call(exports.FailureType, key)) {
            if (exports.FailureType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function FailureTypeFromJSON(json) {
    return FailureTypeFromJSONTyped(json, false);
}
function FailureTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function FailureTypeToJSON(value) {
    return value;
}
function FailureTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FailureType.js.map